import { render, staticRenderFns } from "./authenticAtionPending.vue?vue&type=template&id=35c3e90f&scoped=true"
import script from "./authenticAtionPending.vue?vue&type=script&lang=js"
export * from "./authenticAtionPending.vue?vue&type=script&lang=js"
import style0 from "./authenticAtionPending.vue?vue&type=style&index=0&id=35c3e90f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3e90f",
  null
  
)

export default component.exports